// @flow

import React from 'react';
import {connect} from 'react-redux';
import {get} from 'lodash';
import {withStyles} from '@material-ui/core/styles';

import {isMobile} from '../../app/configuration/util';
import {
  applyFilter,
  clear,
  clearFilter,
  updateChipFilter,
  updateConstrainedFilters,
  loadGroups,
  loadOerTypes,
  loadTerminals,
  searchDriverVehicle
} from '../libraryFilterActions';
import DesktopFilter from './DesktopFilters';
import MobileFilter from './MobileFilters';

const styleSheet = () => ({
  flex: {
    flex: 1
  }
});

export const LibraryFilters = props => {
  return props.isMobile ? <MobileFilter {...props} /> : <DesktopFilter {...props} />;
};

function mapStateToProps(state) {
  const {libraryFilters, customer} = state;
  const oerTypeFilter = get(libraryFilters, 'selectedFilters.oerTypeFilter');
  const terminalsFilter = get(libraryFilters, 'selectedFilters.terminalsFilter');
  const groupsFilter = get(libraryFilters, 'selectedFilters.groupsFilter');
  const constrainedFilters = get(libraryFilters, 'selectedFilters.constrainedFilters');
  const chipsFilter = get(libraryFilters, 'selectedFilters.chipsFilter');
  const mediaId = get(libraryFilters, 'filters.mediaId');
  const startTime = get(libraryFilters, 'selectedFilters.startTime');
  const endTime = get(libraryFilters, 'selectedFilters.endTime');
  return {
    isMobile: isMobile(state),
    customer,
    ...libraryFilters,
    oerTypeFilter,
    terminalsFilter,
    groupsFilter,
    constrainedFilters,
    chipsFilter,
    mediaId,
    startTime,
    endTime
  };
}

const mapDispatchToProps = dispatch => ({
  searchDriverVehicle: params => dispatch(searchDriverVehicle(params)),
  applyFilter: filters => dispatch(applyFilter(filters)),
  loadGroups: () => dispatch(loadGroups()),
  loadOerTypes: () => dispatch(loadOerTypes()),
  loadTerminals: () => dispatch(loadTerminals()),
  clearFilter: () => dispatch(clearFilter()),
  clear: () => dispatch(clear()),
  updateChipFilter: chips => dispatch(updateChipFilter(chips)),
  updateConstrainedFilters: filters => dispatch(updateConstrainedFilters(filters))
});

// export default withStyles(styleSheet)(LibraryFilters);
// export default connect(mapStateToProps)(LibraryFilters);
const stylished = withStyles(styleSheet)(LibraryFilters);
export default connect(mapStateToProps, mapDispatchToProps)(stylished);
